import { render, staticRenderFns } from "./idcSupport.vue?vue&type=template&id=705af9dc&scoped=true"
import script from "./idcSupport.vue?vue&type=script&lang=js"
export * from "./idcSupport.vue?vue&type=script&lang=js"
import style0 from "./idcSupport.vue?vue&type=style&index=0&id=705af9dc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705af9dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('705af9dc')) {
      api.createRecord('705af9dc', component.options)
    } else {
      api.reload('705af9dc', component.options)
    }
    module.hot.accept("./idcSupport.vue?vue&type=template&id=705af9dc&scoped=true", function () {
      api.rerender('705af9dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workOrder/other/idcSupport.vue"
export default component.exports